/**
 * EventfrogRubric entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class EventfrogRubric extends BaseModel {
    defaults() {
        return {
            id: null,
            db_id: null,
            parent_id: null,
            rubric: null,
            parent_rubric: null,
            genre_group_id: null,
            genre_group: null,
            display_field: null,
        };
    }

    mutations() {
        return {
            id: Number,
            db_id: (db_id) => (Number(db_id) > 0 ? Number(db_id) : null),
            parent_id: Number,
            genre_group_id: Number,
        };
    }

    options() {
        return {
            identifier: 'db_id',
        };
    }

    entityName() {
        return 'EventfrogRubric';
    }
}

export class EventfrogRubricCollection extends BaseCollection {
    options() {
        return {
            model: EventfrogRubric,
        };
    }

    entityName() {
        return 'EventfrogRubric';
    }
}
